(() => {
	"use strict";
	var e = {
			"./src/js/formatMoney.js"(e, t, r) {
				function a(e, t) {
					"string" == typeof e && (e = e.replace(".", ""));
					var r = "",
						a = /\{\{\s*(\w+)\s*\}\}/,
						n = t || "${{amount}}";

					function o(e, t) {
						return void 0 === e ? t : e
					}

					function i(e, t, r, a) {
						if (t = o(t, 2), r = o(r, ","), a = o(a, "."), isNaN(e) || null == e) return 0;
						var n, i = (e = (e / 100).toFixed(t)).split(".");
						return i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + r) + (i[1] ? a + i[1] : "")
					}
					switch (n.match(a)[1]) {
						case "amount":
							r = i(e, 2);
							break;
						case "amount_no_decimals":
							r = i(e, 0);
							break;
						case "amount_with_comma_separator":
							r = i(e, 2, ".", ",");
							break;
						case "amount_no_decimals_with_comma_separator":
							r = i(e, 0, ".", ",");
							break;
						case "amount_with_apostrophe_separator":
							r = i(e, 2, "'", ".")
					}
					return n.replace(a, r)
				}
				r.r(t), r.d(t, {
					formatMoney: () => a
				})
			},
			"./node_modules/smooth-zoom/dist/zoom.esm.js"(e, t, r) {
				function a(e, t = {}) {
					let r = t.originalizer || (e => e),
						a = {
							screenWidth: 0,
							screenHeight: 0,
							scrollBar: 0
						},
						n = t.background,
						o = () => {
							let {
								documentElement: e
							} = document;
							a.screenWidth = window.innerWidth || e.clientWidth, a.screenHeight = window.innerHeight || e.clientHeight, a.scrollBar = a.screenWidth - e.offsetWidth
						},
						i = e => {
							let t = e.currentSrc || e.src,
								{
									srcset: o
								} = e,
								{
									screenWidth: i,
									screenHeight: c,
									scrollBar: s
								} = a,
								{
									width: u,
									height: d,
									left: p,
									top: v
								} = e.getBoundingClientRect(),
								f = document.createElement("div"),
								m = document.createElement("img"),
								y = e.naturalWidth,
								h = () => {
									f.classList.remove("zoom-bg--reveal"), m.style.transform = "", m.addEventListener("transitionend", () => {
										f.remove(), e.classList.remove("zoom-original--hidden"), m.remove()
									}, {
										once: !0
									}), f.removeEventListener("click", h), m.removeEventListener("click", h), window.removeEventListener("scroll", h), window.removeEventListener("resize", h)
								};
							if (f.classList.add("zoom-bg"), n) {
								if ("auto" === n) {
									let b = l(e);
									f.style.background = b ? `rgb(${b.r}, ${b.g}, ${b.b})` : "rgb(0, 0, 0)"
								} else f.style.background = n
							}
							if (o) {
								let g = o.match(/ ([0-9]+)w/gm);
								g && (y = g.map(e => +e.trim().replace("w", "")).filter(e => !isNaN(e)).reduce((e, t) => Math.max(e, t), 0))
							}
							y = Math.min(y, i);
							let $ = y * (d / u);
							$ >= c && (y = y * c / $), m.classList.add("zoom-img"), m.src = t, m.width = u, m.height = d, f.addEventListener("click", h, {
								once: !0
							}), m.addEventListener("click", h, {
								once: !0
							}), window.addEventListener("scroll", h, {
								once: !0,
								passive: !0
							}), window.addEventListener("resize", h, {
								once: !0,
								passive: !0
							}), document.body.append(f, m), m.style.top = `${v+window.scrollY}px`, m.style.left = `${p}px`, m.style.width = `${u}px`, m.style.height = `${d}px`, e.classList.add("zoom-original--hidden");
							let S = y !== u ? y / u : 1;
							m.style.transform = `matrix(${S}, 0, 0, ${S}, ${(i-s)/2-p-u/2}, ${-v+(c-d)/2})`, f.classList.add("zoom-bg--reveal"), m.addEventListener("transitionend", () => {
								m.src = r(t)
							}, {
								once: !0
							})
						},
						c = e => {
							i(e.target)
						},
						l = e => {
							let t = {
									r: 0,
									g: 0,
									b: 0
								},
								r = document.createElement("canvas"),
								a = r.getContext("2d");
							if (!a) return null;
							let n = r.width = e.naturalWidth || e.offsetWidth || e.width,
								o = r.height = e.naturalHeight || e.offsetHeight || e.height,
								i, c = -4,
								l, s = 0;
							a.drawImage(e, 0, 0);
							try {
								i = a.getImageData(0, 0, n, o)
							} catch (u) {
								return null
							}
							for (l = i.data.length;
								(c += 20) < l;) ++s, t.r += i.data[c], t.g += i.data[c + 1], t.b += i.data[c + 2];
							return t.r = Math.floor(t.r / s), t.g = Math.floor(t.g / s), t.b = Math.floor(t.b / s), t
						},
						s = e => {
							if (e && ("string" == typeof e ? document.querySelectorAll(e).forEach(u) : e instanceof HTMLElement ? u(e) : (e instanceof NodeList || e instanceof Array) && e.forEach(u), "string" == typeof e)) {
								let t = document.createElement("style"),
									r = document.head || document.getElementsByTagName("head")[0];
								t.appendChild(document.createTextNode(`${e}{cursor:zoom-in}`)), r.appendChild(t)
							}
						},
						u = e => {
							if (e instanceof HTMLElement) {
								if ("IMG" === e.tagName) e.addEventListener("click", c);
								else {
									let t = e.querySelector("img");
									t && t.addEventListener("click", c)
								}
							}
						};
					return o(), window.addEventListener("resize", o, {
						passive: !0
					}), s(e), {
						zoom: i,
						attach: s
					}
				}
				r.r(t), r.d(t, {
					default: () => a
				}), ! function e(t, r) {
					void 0 === r && (r = {});
					var a = r.insertAt;
					if (t && "undefined" != typeof document) {
						var n = document.head || document.getElementsByTagName("head")[0],
							o = document.createElement("style");
						o.type = "text/css", "top" === a && n.firstChild ? n.insertBefore(o, n.firstChild) : n.appendChild(o), o.styleSheet ? o.styleSheet.cssText = t : o.appendChild(document.createTextNode(t))
					}
				}(".zoom-bg,.zoom-img{cursor:zoom-out;z-index:90000}.zoom-img{display:block;position:absolute;transition:transform .3s ease-in-out;will-change:transform}.zoom-bg{background:#121212;height:100vh;left:0;opacity:0;position:fixed;top:0;transition:opacity .3s ease-in-out;width:100vw;will-change:opacity}.zoom-bg.zoom-bg--reveal{opacity:.95}.zoom-original--hidden{visibility:hidden}")
			}
		},
		t = {};

	function r(a) {
		var n = t[a];
		if (void 0 !== n) return n.exports;
		var o = t[a] = {
			exports: {}
		};
		return e[a](o, o.exports, r), o.exports
	}
	r.d = (e, t) => {
		for (var a in t) r.o(t, a) && !r.o(e, a) && Object.defineProperty(e, a, {
			enumerable: !0,
			get: t[a]
		})
	}, r.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), r.r = e => {
		"undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
			value: "Module"
		}), Object.defineProperty(e, "__esModule", {
			value: !0
		})
	};
	var a = {};
	(() => {
		/*!***************************!*\
		  !*** ./src/js/product.js ***!
		  \***************************/
		r.r(a);
		var e = r( /*! smooth-zoom */ "./node_modules/smooth-zoom/dist/zoom.esm.js"),
			t = r( /*! ./formatMoney */ "./src/js/formatMoney.js");

		function n(e, t) {
			var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
			if (!r) {
				if (Array.isArray(e) || (r = o(e)) || t && e && "number" == typeof e.length) {
					r && (e = r);
					var a = 0,
						n = function e() {};
					return {
						s: n,
						n: function t() {
							return a >= e.length ? {
								done: !0
							} : {
								done: !1,
								value: e[a++]
							}
						},
						e: function e(t) {
							throw t
						},
						f: n
					}
				}
				throw TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
			}
			var i, c = !0,
				l = !1;
			return {
				s: function t() {
					r = r.call(e)
				},
				n: function e() {
					var t = r.next();
					return c = t.done, t
				},
				e: function e(t) {
					l = !0, i = t
				},
				f: function e() {
					try {
						c || null == r.return || r.return()
					} finally {
						if (l) throw i
					}
				}
			}
		}

		function o(e, t) {
			if (e) {
				if ("string" == typeof e) return i(e, t);
				var r = Object.prototype.toString.call(e).slice(8, -1);
				if ("Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r) return Array.from(e);
				if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return i(e, t)
			}
		}

		function i(e, t) {
			(null == t || t > e.length) && (t = e.length);
			for (var r = 0, a = Array(t); r < t; r++) a[r] = e[r];
			return a
		}(0, e.default)(".zoomable");
		var c, l = function e() {
			var e = document.querySelector("#product-variants"),
				r = e.querySelectorAll('input[type="radio"]'),
				a = e.querySelectorAll("fieldset"),
				n = document.querySelector('.product-info form[action="/cart/add"] input[name="id"]'),
				o = document.querySelector('.product-info form[action="/cart/add"] button[type="submit"]'),
				i = function t() {
					return JSON.parse(e.querySelector('[type="application/json"]').textContent)
				},
				c = function e(t) {
					var r = t.closest("fieldset"),
						a = r.querySelector("legend").getAttribute("data-fieldset-label");
					r.querySelector("legend span").innerHTML = a + ': <span class="uppercase font-bold">' + t.value + "</span>"
				},
				l = function e(t) {
					t ? (o.classList.remove("btn-disabled"), o.classList.add("btn-primary"), o.innerHTML = window.product.addToCart, o.disabled = !1) : (o.classList.add("btn-disabled"), o.classList.remove("btn-primary"), o.innerHTML = window.product.soldOut, o.disabled = !0)
				},
				s = function e(r) {
					var a = document.querySelector(".js-product-price"),
						n = document.querySelector(".js-product-compare-at-price"),
						o = i().filter(function(e) {
							return e.id === r
						});
					a.innerHTML = (0, t.formatMoney)(o[0].price, window.theme.moneyFormat), null != o[0].compare_at_price ? (n.classList.remove("hidden"), n.innerHTML = (0, t.formatMoney)(o[0].compare_at_price, window.theme.moneyFormat)) : n.classList.add("hidden")
				},
				u = function e(t) {
					n.value = t.id, s(t.id), l(t.available);
					var r = window.location.href.split("?")[0];
					history.pushState(null, null, r + "?variant=" + t.id)
				},
				d = function t(r) {
					1 === a.length && e.querySelectorAll(".js-unavailable-variant").forEach(function(e) {
						e.classList.remove("js-unavailable-variant")
					}), r.forEach(function(t, n) {
						if (0 === n && (1 === a.length ? o = i().filter(function(e) {
								return !1 === e.available
							}) : 2 === a.length ? o = i().filter(function(e) {
								return e.option1 === r[0].value
							}).sort(function(e) {
								return e.available ? 1 : -1
							}) : a.length > 2 && (o = i().filter(function(e) {
								return e.option1 === r[0].value && e.option2 === r[1].value
							}).sort(function(e) {
								return e.available ? 1 : -1
							})), o.forEach(function(t) {
								1 === a.length && e.querySelector('.js-variant-label[data-label-value="'.concat(t.option1, '"]')).classList.add("js-unavailable-variant"), a.length >= 2 && (t.available ? e.querySelector('.js-variant-label[data-label-value="'.concat(t.option2, '"]')).classList.remove("js-unavailable-variant") : e.querySelector('.js-variant-label[data-label-value="'.concat(t.option2, '"]')).classList.add("js-unavailable-variant")), a.length > 2 && (t.available ? e.querySelector('.js-variant-label[data-label-value="'.concat(t.option3, '"]')).classList.remove("js-unavailable-variant") : e.querySelector('.js-variant-label[data-label-value="'.concat(t.option3, '"]')).classList.add("js-unavailable-variant"))
							})), 1 === n && (2 === a.length ? c = i().filter(function(e) {
								return e.option2 === r[1].value
							}).sort(function(e) {
								return e.available ? 1 : -1
							}) : a.length > 2 && (c = i().filter(function(e) {
								return e.option2 === r[1].value && e.option3 === r[2].value
							}).sort(function(e) {
								return e.available ? 1 : -1
							})), c.forEach(function(t) {
								a.length >= 2 && (t.available ? e.querySelector('.js-variant-label[data-label-value="'.concat(t.option1, '"]')).classList.remove("js-unavailable-variant") : e.querySelector('.js-variant-label[data-label-value="'.concat(t.option1, '"]')).classList.add("js-unavailable-variant")), a.length > 2 && (t.available ? e.querySelector('.js-variant-label[data-label-value="'.concat(t.option3, '"]')).classList.remove("js-unavailable-variant") : e.querySelector('.js-variant-label[data-label-value="'.concat(t.option3, '"]')).classList.add("js-unavailable-variant"))
							})), 2 === n) {
							var o, c;
							i().filter(function(e) {
								return e.option3 === r[2].value && e.option1 === r[0].value
							}).sort(function(e) {
								return e.available ? 1 : -1
							}).forEach(function(t) {
								t.available ? e.querySelector('.js-variant-label[data-label-value="'.concat(t.option1, '"]')).classList.remove("js-unavailable-variant") : e.querySelector('.js-variant-label[data-label-value="'.concat(t.option1, '"]')).classList.add("js-unavailable-variant"), t.available ? e.querySelector('.js-variant-label[data-label-value="'.concat(t.option2, '"]')).classList.remove("js-unavailable-variant") : e.querySelector('.js-variant-label[data-label-value="'.concat(t.option2, '"]')).classList.add("js-unavailable-variant")
							})
						}
					})
				};
			r.forEach(function(t) {
				return t.addEventListener("change", function() {
					var r = e.querySelectorAll('input[type="radio"]:checked'),
						n = r[0].value;
					a.length >= 2 && (n += " / " + r[1].value), a.length > 2 && (n += " / " + r[2].value);
					var o = i().filter(function(e) {
						return e.title === n
					});
					u(o[0]), c(t), d(r)
				})
			}), d(e.querySelectorAll('input[type="radio"]:checked'))
		};
		document.querySelector(".single-variant") || l();
		var s, u = function e() {
			document.querySelectorAll(".js-prod-btn-group").forEach(function(e) {
				var r, a = parseInt(e.getAttribute("data-cv-price")),
					n = parseInt(e.querySelector(".js-input-quantity").value);
				e.querySelector(".js-total-price"), r = (0, t.formatMoney)(a * n, window.theme.moneyFormat).replace(".00", "")
			})
		};
		document.querySelectorAll(".js-btn-quantity").forEach(function(e) {
			e.addEventListener("click", function(e) {
				u();
				let r = document.querySelector(".product-info .js-input-quantity").value,
					a = document.querySelector(".js-product-price.js-inc-vat").dataset.price,
					n = document.querySelector(".js-product-price.js-ex-vat").dataset.price;
				if (document.querySelector(".js-product-compare-at-price.js-inc-vat")) {
					let o = document.querySelector(".js-product-compare-at-price.js-inc-vat").dataset.compareprice;
					document.querySelector(".js-product-price.js-inc-vat").innerHTML = (0, t.formatMoney)(r * a, window.theme.moneyFormat).replace(".00", ""), document.querySelector(".js-product-compare-at-price.js-inc-vat").innerHTML = (0, t.formatMoney)(r * o, window.theme.moneyFormat).replace(".00", "")
				} else document.querySelector(".js-product-price.js-inc-vat").innerHTML = (0, t.formatMoney)(r * a, window.theme.moneyFormat).replace(".00", "");
				if (document.querySelector(".js-product-compare-at-price.js-ex-vat")) {
					let i = document.querySelector(".js-product-compare-at-price.js-ex-vat").dataset.compareprice;
					document.querySelector(".js-product-price.js-ex-vat").innerHTML = (0, t.formatMoney)(r * n, window.theme.moneyFormat).replace(".00", ""), document.querySelector(".js-product-compare-at-price.js-ex-vat").innerHTML = (0, t.formatMoney)(r * i, window.theme.moneyFormat).replace(".00", "")
				} else document.querySelector(".js-product-price.js-ex-vat").innerHTML = (0, t.formatMoney)(r * n, window.theme.moneyFormat).replace(".00", "")
			})
		});
		var d = document.querySelector(".product-images-container"),
			p = d ? Array.from(d.querySelectorAll(".product-image")) : [],
			v = document.querySelector(".js-load-more"),
			f = document.querySelector(".images-shown").value,
			m = document.querySelector(".images-toshow").value,
			y = document.querySelector(".images-left"),
			h = document.querySelector(".images-count-text"),
			b = "lg:hidden";

		function g() {
			var e, t = 0,
				r = n(p);
			try {
				for (r.s(); !(e = r.n()).done;) e.value.classList.contains(b) && t++
			} catch (a) {
				r.e(a)
			} finally {
				r.f()
			}(t -= m) < m && (y.innerHTML = t), 1 == t && (h.innerHTML = "image")
		}

		function $(e, t, r) {
			var a = '<div class="product-colours">';
			if (!0 == r) {
				var n = [],
					o = [],
					i = Object.values(e.products);
				i.sort(function(e, t) {
					return parseInt(e.size) - parseInt(t.size)
				});
				for (var c = 0; c < i.length; c++) {
					var l = parseInt(i[c].id),
						s = i[c].colour,
						u = i[c].url;
					i.size;
					var d = i[c].size,
						p = n.findIndex(function(e) {
							return e.colour === s
						});
					if (l === t) var v = s,
						f = d; - 1 == p && n.push({
						colour: s,
						url: u,
						size: d
					}), o.push({
						id: l,
						colour: s,
						url: u,
						size: d
					})
				}
				n.forEach(function(e) {
					for (var t = "btn-colour-swatch " + e.colour.toLowerCase() + " cursor-pointer", r = null, n = 0; n < i.length; n++) {
						var o = i[n].colour,
							c = i[n].size;
						if (o === e.colour && c === f) {
							r = i[n];
							break
						}
					}
					var h = r ? (r.handle || r.url.split('/products/')[1]?.split('?')[0] || '') : (e.handle || e.url.split('/products/')[1]?.split('?')[0] || '');
					var u = r ? r.url : e.url;
					t.includes(v) && (t += " current", document.querySelector(".product-colours-container .cc__current").innerText = e.colour), a += '<div class="cc-swatch-container"><button type="button" class="' + t + '" data-product-handle="' + h + '" data-product-url="' + u + '" data-colour-name="' + e.colour + '" title="' + e.colour + '"></button></div>'
				})
			} else {
				var n = [],
					o = [],
					i = Object.values(e.products);
				i.sort(function(e, t) {
					return parseInt(e.size) - parseInt(t.size)
				});
				for (var c = 0; c < i.length; c++) {
					var l = parseInt(i[c].id),
						s = i[c].colour,
						u = i[c].url,
						d = i[c].size,
						p = n.findIndex(function(e) {
							return e.colour === s
						});
					if (l === t) var v = s; - 1 == p && n.push({
						colour: s,
						url: u,
						size: d
					}), o.push({
						id: l,
						colour: s,
						url: u,
						size: d
					})
				}
				n.forEach(function(e) {
					var t = "btn-colour-swatch " + e.colour.toLowerCase() + " cursor-pointer";
					var h = e.handle || e.url.split('/products/')[1]?.split('?')[0] || '';
					t.includes(v) && (t += " current", document.querySelector(".product-colours-container .cc__current").innerText = e.colour), a += '<div class="cc-swatch-container"><button type="button" class="' + t + '" data-product-handle="' + h + '" data-product-url="' + e.url + '" data-colour-name="' + e.colour + '" title="' + e.colour + '"></button></div>'
				})
			}
			setTimeout(function() {
				document.querySelectorAll(".btn-size-swatch").forEach(function(e) {
					e.classList.contains(v) ? (e.classList.remove("hidden"), e.parentElement.querySelector("span").classList.remove("hidden")) : e.parentElement.remove()
				})
			}, 300), a += "</div>", document.querySelector(".product-colours-container").querySelector(".title").insertAdjacentHTML("afterend", a)
		}

		function S() {
			var e = document.querySelector(".product-colours-container");
			if (document.querySelector(".product-sizes-container")) var t = !0;
			else var t = !1;
			if (e) {
				var r = e.getAttribute("data-colour-group"),
					a = parseInt(e.getAttribute("data-current-product-id"));
				if (e.getAttribute("data-colour-group")) {
					var n = new XMLHttpRequest;
					n.onreadystatechange = function() {
						if (4 == this.readyState && 200 == this.status) {
							var e = this.responseText;
							if (e) try {
								var r = JSON.parse(e)
							} catch (n) {
								var r = null
							}
							r && $(r, a, t)
						}
					}, n.open("GET", "/collections/all/" + r + "?view=swatch", !0), n.send()
				}
			}
		}

		function j(e, t) {
			var r = '<div class="product-sizes flex flex-wrap cc-gap-x-[30px] cc-gap-y-[10px]">',
				productsArray = Object.values(e.products),
				currentProduct = productsArray.find(function(p) { return parseInt(p.id) === t; }),
				currentColour = currentProduct ? currentProduct.colour : null,
				a = productsArray.filter(function(p) {
					return currentColour ? p.colour === currentColour : true;
				}).sort(function(e, t) {
					if (e.size && t.size) {
						var r = parseInt(e.size),
							a = parseInt(t.size);
						return isNaN(r) || isNaN(a) ? e.size.localeCompare(t.size) : r - a
					}
					return 0
				}),
				renderedSizes = new Set();
			for (var n in a) {
				var o = a[n],
					i = o.size;
				if (renderedSizes.has(i)) continue;
				renderedSizes.add(i);
				var c = o.title,
					l = o.url,
					s = o.available,
					u = parseInt(o.id),
					d = o.colour,
					p = "",
					v = !1;
				h = o.handle || l.split('/products/')[1]?.split('?')[0] || '';
				a.length && (u === t && (p = " current", v = !0, document.querySelector(".product-sizes-container .cc__current").innerText = i), i && (r += '<button type="button" class="btn-size-swatch' + p + " " + d + '" data-product-available="' + s + '" data-product-size="' + i + '" data-product-handle="' + h + '" data-product-url="' + l + '" aria-label="View ' + c + " in " + i + '" tabindex="0">' + i + '</button>'))
			}
			r += "</div>", document.querySelector(".product-sizes-container").querySelector(".title").insertAdjacentHTML("afterend", r)
		}

		function q() {
			var e = document.querySelector(".product-sizes-container");
			if (e) {
				var t = e.getAttribute("data-size-group"),
					r = parseInt(e.getAttribute("data-current-product-id"));
				if (e.getAttribute("data-size-group")) {
					var a = new XMLHttpRequest;
					a.onreadystatechange = function() {
						if (4 == this.readyState && 200 == this.status) {
							var e = this.responseText;
							if (e) try {
								var t = JSON.parse(e);
								console.log(t)
							} catch (a) {
								var t = null
							}
							t && j(t, r)
						}
					}, a.open("GET", "/collections/all/" + t + "?view=swatch", !0), a.send()
				}
			}
		}
		p.splice(0, f).forEach(function(e) {
			return e.classList.remove(b)
		}), v && (v.addEventListener("click", g), 0 == p.length && v.classList.add(b), v.addEventListener("click", function(e) {
			e.preventDefault(), p.splice(0, m).forEach(function(e) {
				return e.classList.remove(b)
			}), 0 == p.length && v.classList.add(b)
		})), setTimeout(function() {
			document.querySelectorAll(".adp-vol-wrapper").forEach(function(e) {
				var t = document.createElement("tr"),
					r = document.createElement("div");
				r.textContent = "Need more?", r.classList.add("cc-h-full", "py-2.5", "px-4", "flex", "flex-col", "cc-text-center", "w-full", "cc-text-[13px]", "cc-font-medium", "text-primary", "items-center", "justify-center", "gap-2");
				var a = document.createElement("a");
				a.href = "https://displaysense.customerdesk.io/#rp-customer-widget-faq-c383772e-0424-4b62-82d3-7949e8f366b1", a.textContent = "Enquire Now", a.classList.add("cc-text-[#759C98]", "transition", "duration-300", "ease-in-out", "hover:text-primary", "cc-underline"), r.appendChild(a), t.appendChild(r), e.querySelector(".adp-discount-table tbody").appendChild(t)
			})
		}, 1e3), q(), S();

		// AJAX Product Switcher - CC Custom
		async function ccFetchProductData(handle) {
			try {
				const response = await fetch('/products/' + handle + '.json');
				if (!response.ok) throw new Error('Product not found');
				const data = await response.json();
				return data.product;
			} catch (error) {
				console.error('Error fetching product:', error);
				return null;
			}
		}

		async function ccFetchProductHTML(handle) {
			try {
				const response = await fetch('/products/' + handle + '?sections=cc-product');
				if (!response.ok) throw new Error('Product section not found');
				const data = await response.json();
				return data['cc-product'];
			} catch (error) {
				console.error('Error fetching product HTML:', error);
				return null;
			}
		}

		function ccUpdateProductPage(product, sectionHTML) {
			// Update page title
			var titleEl = document.querySelector('.cc__producttitle');
			if (titleEl) titleEl.textContent = product.title;

			// Update SKU
			var skuEl = document.querySelector('.cc__productcurrentSKU');
			if (skuEl) {
				var variant = product.variants[0];
				if (variant && variant.sku) {
					skuEl.textContent = 'Product code: ' + variant.sku;
					skuEl.style.display = '';
				} else {
					skuEl.style.display = 'none';
				}
			}

			// Update description (truncated)
			var descEl = document.querySelector('.cc-product-description');
			if (descEl && product.body_html) {
				var plainText = product.body_html.replace(/<[^>]*>/g, '');
				var truncated = plainText.substring(0, 150);
				descEl.innerHTML = truncated + '...<button class="cc-read-more-btn cc-text-[#759C98] cc-underline cc-font-semibold cc-text-[12px]" onclick="scrollToProductDescTab()">Read More</button>';
			}

			// Update prices
			var variant = product.variants[0];
			if (variant) {
				var price = variant.price;
				var comparePrice = variant.compare_at_price;
				var taxPercentage = 1.2; // Default 20% VAT - adjust as needed
				var exVatPrice = Math.round(price / taxPercentage);
				var exVatComparePrice = comparePrice ? Math.round(comparePrice / taxPercentage) : null;

				// Format money helper
				function formatMoney(price) {
					return '£' + parseFloat(price).toFixed(2);
				}

				// Update Inc VAT price
				var incVatPriceEl = document.querySelector('.cc-product-price-display .cc-price-amount.js-inc-vat');
				if (incVatPriceEl) incVatPriceEl.textContent = formatMoney(price);

				// Update Ex VAT price
				var exVatPriceEl = document.querySelector('.cc-product-price-display .cc-price-amount.js-ex-vat');
				if (exVatPriceEl) exVatPriceEl.textContent = formatMoney(exVatPrice);

				// Update compare prices
				var incVatCompareEl = document.querySelector('.cc-product-price-display .cc-price-compare.js-inc-vat');
				var exVatCompareEl = document.querySelector('.cc-product-price-display .cc-price-compare.js-ex-vat');

				if (comparePrice && comparePrice > price) {
					if (incVatCompareEl) {
						incVatCompareEl.textContent = formatMoney(comparePrice);
						incVatCompareEl.style.display = '';
					}
					if (exVatCompareEl) {
						exVatCompareEl.textContent = formatMoney(exVatComparePrice);
						exVatCompareEl.style.display = '';
					}
				} else {
					if (incVatCompareEl) incVatCompareEl.style.display = 'none';
					if (exVatCompareEl) exVatCompareEl.style.display = 'none';
				}

				// Update form variant ID
				var variantInput = document.querySelector('form[action="/cart/add"] input[name="id"]');
				if (variantInput) variantInput.value = variant.id;

				// Update data-cv-price for quantity calculation
				var prodBtnGroup = document.querySelector('.js-prod-btn-group');
				if (prodBtnGroup) prodBtnGroup.setAttribute('data-cv-price', price);
			}

			// Update availability
			var availEl = document.querySelector('.availability');
			if (availEl && variant) {
				if (variant.available) {
					availEl.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="9" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="m2 4.855 3.512 3M13 1.856l-7.025 6"/></svg> In Stock - UK Dispatch';
					availEl.classList.remove('cc-text-red-700');
					availEl.classList.add('cc-text-[#37AC85]');
				} else {
					availEl.innerHTML = '<span class="relative bg-red w-2.5 h-2.5 rounded-full mr-2"></span> Out of Stock';
					availEl.classList.add('cc-text-red-700');
					availEl.classList.remove('cc-text-[#37AC85]');
				}
			}

			// Update images using section HTML if available
			if (sectionHTML) {
				var tempDiv = document.createElement('div');
				tempDiv.innerHTML = sectionHTML;
				var newGallery = tempDiv.querySelector('.cc-flex.cc-flex-col.cc-gap-5');
				var currentGallery = document.querySelector('.product-images .cc-flex.cc-flex-col.cc-gap-5');
				if (newGallery && currentGallery) {
					currentGallery.innerHTML = newGallery.innerHTML;
					// Reinitialize Swiper if present
					if (typeof Swiper !== 'undefined') {
						var swiperEl = currentGallery.querySelector('.swiper');
						if (swiperEl && swiperEl.swiper) {
							swiperEl.swiper.destroy(true, true);
						}
						// Re-init swipers
						document.querySelectorAll('.cc-product-swiper').forEach(function(el) {
							new Swiper(el, {
								slidesPerView: 1,
								spaceBetween: 10,
								pagination: {
									el: '.cc-swiper-pagination',
									clickable: true
								}
							});
						});
					}
				}
			}

			// Update URL without reload
			history.pushState({productHandle: product.handle}, product.title, '/products/' + product.handle);

			// Update document title
			document.title = product.title + ' – ' + (window.Shopify?.shop || 'Store');

			// Update Yotpo widget if present
			var yotpoEl = document.querySelector('.yotpo-widget-instance');
			if (yotpoEl) {
				yotpoEl.setAttribute('data-yotpo-product-id', product.id);
				yotpoEl.setAttribute('data-yotpo-cart-product-id', product.id);
				if (typeof yotpo !== 'undefined' && yotpo.refreshWidgets) {
					yotpo.refreshWidgets();
				}
			}

			// Update swatch container product ID
			var colourContainer = document.querySelector('.product-colours-container');
			if (colourContainer) colourContainer.setAttribute('data-current-product-id', product.id);
			var sizeContainer = document.querySelector('.product-sizes-container');
			if (sizeContainer) sizeContainer.setAttribute('data-current-product-id', product.id);
		}

		async function ccSwitchToProduct(handle, clickedSwatch) {
			if (!handle) return;

			// Add loading state
			var productInfo = document.querySelector('.product-info');
			if (productInfo) productInfo.classList.add('cc-loading');

			// Fetch product data and HTML in parallel
			var [product, sectionHTML] = await Promise.all([
				ccFetchProductData(handle),
				ccFetchProductHTML(handle)
			]);

			if (product) {
				// Update current swatch states
				document.querySelectorAll('.btn-colour-swatch.current, .btn-size-swatch.current').forEach(function(el) {
					el.classList.remove('current');
				});
				if (clickedSwatch) clickedSwatch.classList.add('current');

				// Update colour/size labels
				if (clickedSwatch) {
					var colourName = clickedSwatch.getAttribute('title') || clickedSwatch.getAttribute('data-colour-name');
					var sizeName = clickedSwatch.getAttribute('data-product-size');
					if (colourName && clickedSwatch.classList.contains('btn-colour-swatch')) {
						var colourLabel = document.querySelector('.product-colours-container .cc__current');
						if (colourLabel) colourLabel.textContent = colourName;
					}
					if (sizeName && clickedSwatch.classList.contains('btn-size-swatch')) {
						var sizeLabel = document.querySelector('.product-sizes-container .cc__current');
						if (sizeLabel) sizeLabel.textContent = sizeName;
					}
				}

				// Update the page
				ccUpdateProductPage(product, sectionHTML);

				// Rebuild both swatches to keep them in sync
				var oldColoursDiv = document.querySelector('.product-colours');
				if (oldColoursDiv) oldColoursDiv.remove();
				var oldSizesDiv = document.querySelector('.product-sizes');
				if (oldSizesDiv) oldSizesDiv.remove();
				S();
				q();
			}

			// Remove loading state
			if (productInfo) productInfo.classList.remove('cc-loading');
		}

		// Click event handler for swatches
		document.addEventListener('click', function(e) {
			var swatch = e.target.closest('.btn-colour-swatch, .btn-size-swatch');
			if (swatch && !swatch.classList.contains('current')) {
				e.preventDefault();
				e.stopPropagation();
				var handle = swatch.getAttribute('data-product-handle');
				if (handle) {
					ccSwitchToProduct(handle, swatch);
				}
			}
		});

		// Handle browser back/forward
		window.addEventListener('popstate', function(e) {
			if (e.state && e.state.productHandle) {
				ccSwitchToProduct(e.state.productHandle, null);
			}
		});
	})()
})();